<template>
  <div class="yi">
       <div class="content-width">
            <el-row :gutter="22">
                <!-- 左侧部分 -->
                <el-col :span="18">
                    <el-row>
                        <el-col :span="24" class="r-title">隐私策略</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" class="r-intro">
                            <div id="container" v-html="yinContent"></div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
               
  </div>
</template>

<script>
export default {
  name: 'yi',
  data () {
    return {
        yinContent:"",
    }
  },
  methods:{
         //获得隐私策略
        getYin(){
             let that = this;
            let url = "/privacy/getByflag";
            that.$http
                .post(url)
                .then(res => {
                    if (res.data.code == 200) {
                       const str = res.data.data.content;
                       this.yinContent = str;
                        // const paragraphs = str.split('\n\n');
                        // const container = document.getElementById('container');
                        // paragraphs.forEach(paragraph => {
                        // const p = document.createElement('p');
                        // p.textContent = paragraph;
                        // container.appendChild(p);
                        // });
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message("网络错误！");
                });
        },
  },
  created(){
      let that = this;
      that.getYin();
  }
  
}
</script>

<style scoped>
p{
    text-indent: 2em;
}
#container{
    p{
        text-indent: 2em;  
    }
}
</style>



// WEBPACK FOOTER //
// src/components/yi.vue